import LandingHeader from "@/components/landing/LandingHeader";
import HeroSection from "@/components/landing/HeroSection";
import TrustStrip from "@/components/landing/TrustStrip";
import ServicesSection from "@/components/landing/ServicesSection";
import WhyFamiliesSection from "@/components/landing/WhyFamiliesSection";
import RescueSection from "@/components/landing/RescueSection";
import TestimonialsSection from "@/components/landing/TestimonialsSection";
import FAQSection from "@/components/landing/FAQSection";
import VisitSection from "@/components/landing/VisitSection";
import LandingFooter from "@/components/landing/LandingFooter";

export default function LandingPage() {
  return (
    <div className="landing-root" data-testid="landing-page">
      <LandingHeader />
      <main>
        <HeroSection />
        <TrustStrip />
        <ServicesSection />
        <WhyFamiliesSection />
        <RescueSection />
        <TestimonialsSection />
        <FAQSection />
        <VisitSection />
      </main>
      <LandingFooter />
    </div>
  );
}
